import { OnTrackSignupIntent } from '@zapier/authentication/src/components/global/SSOButton';
import { SignupType } from '@zapier/toolbox-tracking/dist/types';
import { addParamsToUrl } from '@zapier/url-utils';
import { ReactNode, useCallback } from 'react';
import { signupTypeToAuthType, storeAuthType } from '../../../hooks';
import { SocialAuthButton } from '../SocialAuthButton';
import { GoogleLogo } from './GoogleLogo';

export type GoogleSSOButtonProps = {
  children?: ReactNode;
  /** The URL to redirect to after auth is complete */
  next?: string | undefined;
  /** Callback to track signup intent */
  onTrackSignupIntent?: OnTrackSignupIntent;
  /** Query params to be added to url */
  params?: Record<string, string | number | boolean | undefined>;
};

const googleSSOPath = '/google-sso/start?scopes=basic';

export function GoogleSSOButton({
  children = 'Continue with Google',
  next,
  onTrackSignupIntent,
  params = {},
}: GoogleSSOButtonProps) {
  // Build SSO start url
  const ssoStartUrl = addParamsToUrl(googleSSOPath, {
    next,
    ...params,
  });

  const onClick = useCallback(() => {
    const type = SignupType.googleSso;

    const authType = signupTypeToAuthType(type);
    if (authType) {
      storeAuthType(authType);
    }

    // Track that the user wanted to sign up
    if (onTrackSignupIntent) {
      onTrackSignupIntent(type);
    }
  }, [onTrackSignupIntent]);

  return (
    <SocialAuthButton
      href={ssoStartUrl}
      icon={<GoogleLogo />}
      onClick={onClick}
    >
      {children}
    </SocialAuthButton>
  );
}
